if (!window.customElements.get('custom-one-time-single')) {
  window.customElements.define(
    'custom-one-time-single',
    class CustomOneTimeSingle extends window.HTMLElement {
      connectedCallback() {
        this.initDOMElements();
        this.boundHandleSubmit = this.handleSubmit.bind(this);
        this.boundHandleLinkClick = this.handleLinkClick.bind(this);
        this.initEventListeners();
        this.updateCheckoutLink();
      }

      disconnectedCallback() {
        this.removeEventListeners();
      }

      initDOMElements() {
        this.form = this.querySelector('form');
        this.button = this.querySelector('[id$="-order-button"]');
        this.useAddToCart = this.dataset.useAddToCart === 'true';
        this.enableGtmTracking = this.dataset.enableGtmTracking === 'true';
        this.goToCheckout = this.form?.hasAttribute('data-go-to-checkout') ?? false;
        this.variantIdInput = this.form?.querySelector('input[name="id"]');
      }

      initEventListeners() {
        if (this.useAddToCart) {
          this.form?.addEventListener('submit', this.boundHandleSubmit);
          return;
        }

        this.button?.addEventListener('click', this.boundHandleLinkClick);
      }

      removeEventListeners() {
        this.form?.removeEventListener('submit', this.boundHandleSubmit);
        this.button?.removeEventListener('click', this.boundHandleLinkClick);
      }

      handleLinkClick(event) {
        if (!this.enableGtmTracking || !window.SeranovaTracking) {
          return;
        }

        const href = this.button?.getAttribute('href');

        if (!href) {
          return;
        }

        event.preventDefault();
        window.location.href = this.appendTrackingParams(href);
      }

      async handleSubmit(event) {
        if (!this.useAddToCart) {
          return;
        }

        event.preventDefault();

        if (this.isSubmitting || !this.variantIdInput?.value) {
          return;
        }

        this.isSubmitting = true;

        try {
          this.form?.classList.add('is-loading');
          await this.addToCart({
            id: this.variantIdInput.value,
            quantity: 1,
          });

          if (this.goToCheckout) {
            window.location.href = '/checkout';
            return;
          }

          this.dispatchCartRefresh();
        } catch (error) {
          console.error('Failed to add item to cart:', error);
        } finally {
          this.form?.classList.remove('is-loading');
          this.isSubmitting = false;
        }
      }

      updateCheckoutLink() {
        if (this.useAddToCart || !this.button || this.button.tagName !== 'A') {
          return;
        }

        const href = this.button.getAttribute('href');

        if (!href || !this.enableGtmTracking || !window.SeranovaTracking) {
          return;
        }

        this.button.href = this.appendTrackingParams(href);
      }

      async addToCart(item) {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items: [item] }),
        });

        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.message);
        }

        return response.json();
      }

      dispatchCartRefresh() {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('variant:add'));
      }

      appendTrackingParams(url) {
        if (!this.enableGtmTracking || !url || !window.SeranovaTracking) {
          return url;
        }

        return window.SeranovaTracking.appendParams(url);
      }
    },
  );
}
